(function (app, ng) {

    app.controller("editClientReferralController", editClientReferralController);
    editClientReferralController.$inject = ["_", "clientApi", "_formPattern", "$mdDialog", "$rootScope"];
    function editClientReferralController(_, clientApi, _formPattern, $mdDialog, $rootScope) {
        var $ctrl = this;
        $ctrl.Status = '';
        $ctrl.DateAddedOn = null;
       

        var errorAlert = $mdDialog.alert({
            title: "An error saving has occured.  Please try again.",
            ariaLabel: "Error alert",
            ok: "Ok",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                ui: {},
                clear: clear,
                close: close,
                formPattern: _formPattern,
                save: save,
                searchClients: searchClients,
                getClientInfo: getClientInfo,
            });
        
        function close() {
            return $mdDialog.cancel();
        }

        function searchClients(term) {
            return clientApi.searchClients(term).then(function (result) {
                _.remove(result, function (row) { return row.Id === $ctrl.client.Id; });

                ng.forEach($ctrl.referrals,
                    function (referral) {
                        _.remove(result,
                            function (row) {
                                return row.Id === referral.Id;
                            });
                    });

                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                        if (row.Person.NickName) row.Term += ` (${row.Person.NickName})`;
                    });
                return result;
            });
        }
        function getClientInfo(clientId) {
            if (clientId == null) {
                $ctrl.DateAddedOn = null
                $ctrl.Status = null
            }
            else {
                clientApi.getTimeline(clientId, null).then(function (result) {
                    var clientCreatedEvent = result.filter(function (event) {
                        return event.Type === "ClientCreated"
                    })
                    $ctrl.DateAddedOn = new Date(clientCreatedEvent[0].CreatedOn);
                });
                clientApi.get(clientId).then(function (result) {
                    $ctrl.Status = result.Type.Name;
                });
            }

        }

        function clear($event) {
            $ctrl.ui.deleting = true;
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to remove this referral?",
                targetEvent: $event,
                ariaLabel: "Confirm referred by removal",
                ok: "Remove",
                cancel: "Cancel",
                skipHide: true,
                parent: $event.currentTarget.form,
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });
            $mdDialog.show(confirm)
                .then(function () {
                    return clientApi.removeClientReferredBy($ctrl.client.Id)
                        .then(function () {
                            $ctrl.ui.deleting = false;
                            $mdDialog.hide();
                        },
                            function () {
                                $ctrl.ui.deleting = false;
                                errorAlert.parent($event.currentTarget.parentElement);
                                $mdDialog.show(errorAlert);
                            });
                },
                    function () {
                        $ctrl.ui.deleting = false;
                    });
        }

        function save(clientReferral, $event) {
            //$ctrl.clientReferral = !!clientReferral ? clientReferral : $ctrl.clientReferral;
            $ctrl.clientReferral = {
                ReferrerId: $ctrl.client.Id,
                RefereeId: clientReferral.Referee.Id,
                Referee: clientReferral.Referee,
                DateReferredOn: clientReferral.DateReferredOn
            };
            $ctrl.ui.saving = true;
            return clientApi.addClientReferral($ctrl.clientReferral)
                .then(function (response) {
                    $rootScope.$emit("referralAdded", response);
                    $mdDialog.hide();
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    $mdDialog.show(errorAlert.targetEvent($event));
                })
                .finally(function () {$ctrl.ui.saving = false; });
        }
    }
})(window.app, window.angular); //jshint ignore:line